























































import {Component, Vue} from "vue-property-decorator";
import {AuthStore} from "@/modules/auth/store";
import {FormModel} from "ant-design-vue";

@Component({
    name: "Login"
})
export default class extends Vue {
    private form = {
        username: "",
        password: ""
    };

    private rules = {
        username: [{ required: true, message: "Nhập tài khoản", trigger: "change" }],
        password: [{ required: true, message: "Nhập mật khẩu", trigger: "change" }]
    };

    private onSubmit() {
        (this.$refs.formLogin as FormModel).validate(async (valid) => {
            if (!valid) return;
            try {
                await AuthStore.login(this.form);
                await this.$router.push({ name: "home" });
                this.$message.success("Đăng nhập thành công, chuyển hướng về trang chủ");
            } catch (e) {
                this.$message.error(e?.response?.data?.message || "Lỗi");
            }
        })
    }
}
